import type { HomeCardsConfig } from '../../components/home-cards.tsx';

const PAYABLES = '/finance/payables';
const TREASURY = '/finance/treasury';
const key = (card: string) => ({
  title: `finance.homeCards.${card}.title`,
  criterion: `finance.homeCards.${card}.criterion`,
  unit: `finance.homeCards.${card}.unit`,
});

/**
 * Cartões da Visão geral: Financeiro (ADR 0097). Em cada bloco, primeiro Contas a Pagar e depois
 * Tesouraria. Contas a Receber e Reembolsos ainda não têm módulo.
 */
export const FINANCE_CARDS: HomeCardsConfig = {
  queryKey: 'finance',
  endpoint: '/finance/home-cards',
  consultTo: '/finance/pending',
  cards: [
    {
      id: 'overdue_installments',
      section: 'deadline',
      ...key('overdueInstallments'),
      link: { to: PAYABLES, search: { indicator: 'overdue' } },
    },
    {
      id: 'scheduled_past',
      section: 'deadline',
      ...key('scheduledPast'),
      link: { to: PAYABLES, search: { indicator: 'scheduled_past' } },
    },
    {
      id: 'late_receipts',
      section: 'deadline',
      ...key('lateReceipts'),
      link: { to: TREASURY, search: { tab: 'receipts', indicator: 'late_receipts' } },
    },
    {
      id: 'invoice_divergence',
      section: 'pending',
      ...key('invoiceDivergence'),
      attention: true,
      link: { to: PAYABLES, search: { tab: 'invoices', indicator: 'divergence' } },
    },
    {
      id: 'invoice_pending',
      section: 'pending',
      ...key('invoicePending'),
      attention: true,
      link: { to: PAYABLES, search: { tab: 'invoices', indicator: 'pending' } },
    },
    {
      id: 'proposed_adjustments',
      section: 'pending',
      ...key('proposedAdjustments'),
      link: { to: TREASURY, search: { tab: 'balances', indicator: 'proposed_adjustments' } },
    },
    {
      id: 'open_divergences',
      section: 'pending',
      ...key('openDivergences'),
      link: { to: TREASURY, search: { tab: 'reconciliation', indicator: 'open_divergences' } },
    },
  ],
};
